enum ImageEnum {
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
  SVG = 'image/svg+xml'
}

export default ImageEnum
